import "@/App.css";
import { Toaster } from "sonner";
import { CONTENT } from "@/content";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EventSection } from "@/components/EventSection";
import { LocationSection } from "@/components/LocationSection";
import { VisionSection } from "@/components/VisionSection";
import { ParticipateSection } from "@/components/ParticipateSection";
import { Countdown } from "@/components/Countdown";
import { JoinSection } from "@/components/JoinSection";
import { Footer } from "@/components/Footer";

function App() {
  const t = CONTENT;

  return (
    <div className="legend-app min-h-screen bg-[#0D0B0A] text-[#F4F0E6]">
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: "#1A1715", color: "#F4F0E6", border: "1px solid rgba(244,240,230,0.1)" } }} />
      <Nav t={t} />
      <main>
        <Hero t={t} />
        <EventSection t={t} />
        <LocationSection t={t} />
        <VisionSection t={t} />
        <ParticipateSection t={t} />
        <Countdown t={t} />
        <JoinSection t={t} />
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
